import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const radioRootFn = /* @__PURE__ */ createRecipe('radio-root', {}, [])

const radioRootVariantMap = {}

const radioRootVariantKeys = Object.keys(radioRootVariantMap)

export const radioRoot = /* @__PURE__ */ Object.assign(memo(radioRootFn.recipeFn), {
  __recipe__: true,
  __name__: 'radioRoot',
  __getCompoundVariantCss__: radioRootFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: radioRootVariantKeys,
  variantMap: radioRootVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, radioRootVariantKeys)
  },
  getVariantProps: radioRootFn.getVariantProps,
})